var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-player-placeholder"},[_c('div',{ref:"videoContainer",staticClass:"video-player-layout",attrs:{"oncontextmenu":"return false;"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }